export const discussionsData = [
  {
    id: 1,
    name: "Dianne Russell",
    time: "2 hours ago",
    status: "Online",
    message: "I’m sorry, but I can’t help you with that.",
    image: require("../assets/images/discussion1.png"),
  },
  {
    id: 2,
    name: "Darrel Stevens",
    time: "2 hours ago",
    status: "Online",
    message: "No problem, I’ll be happy to help you.",
    image: require("../assets/images/discussion2.png"),
  },
  {
    id: 3,
    name: "Freida Varns",
    time: "2 hours ago",
    status: "Offline",
    message: "I’m sorry, but I can’t help you with that.",
    image: require("../assets/images/discussion3.png"),
  },
];

export const lookingForHostsData = [
  {
    id: 1,
    name: "Dianne Russell",
    username: "@DianneRussell",
    avatar: require("../assets/images/discussion1.png"),
    location: "Los Angeles",
    references: 71,
    nights: "2 nights",
    dateRange: "Fri Mar 14 Sun Mar 16",
    travelers: "1 Traveler",
    description:
      "I’m looking to connect with locals and fellow travelers, get some recommendations on must-see spots, and maybe find a host who can share their favorite LA experiences with me. I’d love to hear any tips on navigating the city, especially for marathon weekend!",
  },
  {
    id: 2,
    name: "Jacob Jones",
    username: "@JacobJones",
    avatar: require("../assets/images/discussion2.png"),
    location: "New York",
    references: 45,
    nights: "3 nights",
    dateRange: "Mon Apr 8 Wed Apr 10",
    travelers: "2 Travelers",
    description:
      "Traveling to NYC for the first time. Looking for hosts and some guidance on local spots. Recommendations for vegan food and cultural activities would be amazing!",
  },
  {
    id: 3,
    name: "Courtney Henry",
    username: "@CourtneyHenry",
    avatar: require("../assets/images/discussion3.png"),
    location: "Chicago",
    references: 89,
    nights: "1 night",
    dateRange: "Sat Apr 20 Sun Apr 21",
    travelers: "1 Traveler",
    description:
      "Quick trip to Chicago for a conference. Would love to meet someone local to show me around or offer a place to stay just for one night.",
  },
];

export const tagsData = [
  { id: 1, name: "#freeEvent" },
  { id: 2, name: "#new" },
  { id: 3, name: "#tech" },
  { id: 4, name: "#innovation" },
  { id: 5, name: "#meetup" },
];

export const groupsData = [
  {
    id: 1,
    title: "Hitchhikers",
    image: require("../assets/images/groups1.png"),
    discussion: "3,900",
    members: "1,200",
    creator: "@MichelleNguyen",
  },
  {
    id: 2,
    title: "Travel Buddies",
    image: require("../assets/images/groups2.png"),
    discussion: "1,200",
    members: "800",
    creator: "@JohnDoe",
  },
  {
    id: 3,
    title: "Foodies Unite",
    image: require("../assets/images/groups3.png"),
    discussion: "2,500",
    members: "1,000",
    creator: "@JaneSmith",
  },
];

export const discussionDetailData = [
  {
    id: 1,
    name: "Dianne Russell",
    image: require("../assets/images/discussion1.png"),
    time: "2 hours ago",
    title: "Hitchhike event from 22.8 to 5.9 Germany / Austria to Albania",
    msg: "Sed adipiscing consectetur velit fringilla sed varius. Egestas eget proin aenean tincidunt eu at habitant commodo ultricies. Ipsum in facilisis pharetra hendrerit. Velit maecenas fusce egestas scelerisque sed. Accumsan venenatis gravida tellus mi egestas. Amet.",
    replies: [
      {
        id: 1,
        name: "Dianne Russell",
        image: require("../assets/images/discussion1.png"),
        time: "2 hours ago",
        msg: "I’m sorry, but I can’t help you with that.",
      },
      {
        id: 2,
        name: "Darrel Stevens",
        image: require("../assets/images/discussion2.png"),
        time: "2 hours ago",
        msg: "No problem, I’ll be happy to help you.",
      },
      {
        id: 3,
        name: "Freida Varns",
        image: require("../assets/images/discussion3.png"),
        time: "2 hours ago",
        msg: "I’m sorry, but I can’t help you with that.",
      },
    ],
  },
];

export const forumComments = [
  {
    id: 1,
    name: "Dianne Russell",
    comment:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    time: "2 hours ago",
    replies: [],
  },
  {
    id: 2,
    name: "Darrel Stevens",
    comment: "No problem, I’ll be happy to help you.",
    time: "2 hours ago",
    replies: [
      {
        id: 1,
        name: "Jacob Jones",
        comment: "I’m sorry, but I can’t help you with that.",
        time: "2 hours ago",
      },
      {
        id: 2,
        name: "Courtney Henry",
        comment: "Free event in the city this weekend!",
        time: "2 hours ago",
      },
    ],
  },
  {
    id: 3,
    name: "Freida Varns",
    comment: "I’m sorry, but I can’t help you with that.",
    time: "2 hours ago",
    replies: [],
  },
];

export const msgsTabs = [
  { id: 1, name: "All", value: "all" },
  { id: 2, name: "Hosting", value: "hosting" },
  { id: 3, name: "Archived", value: "archived" },
];

export const conversationData = [
  {
    id: 1,
    image: require("../assets/images/discussion1.png"),
    name: "Dianne Russell",
    time: "2 hours ago",
    lastMsg: "I’m sorry, but I can’t help you with that.",
  },
  {
    id: 2,
    image: require("../assets/images/discussion2.png"),
    name: "Darrel Stevens",
    time: "2 hours ago",
    lastMsg: "No problem, I’ll be happy to help you.",
  },
  {
    id: 3,
    image: require("../assets/images/discussion3.png"),
    name: "Freida Varns",
    time: "2 hours ago",
    lastMsg: "I’m sorry, but I can’t help you with that.",
  },
];

export const messagesData = [
  {
    id: 1,
    image: require("../assets/images/discussion1.png"),
    name: "Dianne Russell",
    time: "2 hrs ago",
    msg: "I’m sorry, but I can’t help you with that. I’m sorry, but I can’t help you with that. I’m sorry, but I can’t help you with that.",
  },
  {
    id: 2,
    image: require("../assets/images/discussion2.png"),
    name: "Darrel Stevens",
    time: "2 hrs ago",
    sender: true,
    msg: "No problem, I’ll be happy to help you.",
  },
  {
    id: 3,
    image: require("../assets/images/discussion1.png"),
    name: "Dianne Russell",
    time: "2 hrs ago",
    msg: "I’m sorry, but I can’t help you with that.",
  },
];

export const pointsData = [
  { id: 1, name: "Confirm My Email", points: 20 },
  { id: 2, name: "Add your Phone Number", points: 50 },
  { id: 3, name: "Connect to Facebook", points: 20 },
  { id: 4, name: "Get Verified", points: 5 },
  { id: 5, name: "Upload Profile Photo", points: 20 },
  { id: 6, name: "Add your interests", points: 5 },
  { id: 7, name: "Describe yourself in 'About Me'", points: 20 },
];
